import AxiosStatic from 'axios';
import axios from '../../../../util/service';
import {
    SET_INSIGHTS,
    SET_IS_LOADING_INSIGHTS,
    SET_AVAILABLE_INSIGHT_FILTERS,
    SET_INSIGHTS_API_ERROR,
    SET_INSIGHT_QUERY, RESET_INSIGHTS, SET_LOADING_MORE_INSIGHTS,
} from '../../mutation-types';

const updateBrowserHistory = (queryString) => {
    if (queryString) {
        // make sure that the queries will be visible via url
        history.replaceState({}, '', `?${ queryString }`);
    }
};

export function fetchInsights({ commit }, { params, cancelToken, isLoadingMore = false }) {
    // eslint-disable-next-line no-unused-vars
    const { page, ...queryParams } = params;
    const querySearchParams = new URLSearchParams(queryParams);
    const queryString = querySearchParams.toString();

    if (isLoadingMore) {
        commit(SET_LOADING_MORE_INSIGHTS, { isLoading: true });
    } else {
        commit(SET_IS_LOADING_INSIGHTS, { isLoading: true });
    }

    const hideLoader = () => {
        commit(SET_IS_LOADING_INSIGHTS, { isLoading: false });
        commit(SET_LOADING_MORE_INSIGHTS, { isLoading: false });
    };
    const onSuccess = ({ data }) => {
        // update the browser history with the new filters
        updateBrowserHistory(queryString);
        hideLoader();

        // remove previous errors
        commit(SET_INSIGHTS_API_ERROR, { error: null });
        commit(SET_INSIGHTS, data);

        return data;
    };
    const onError = (error) => {
        // skip axios abort requests
        if (!AxiosStatic.isCancel(error)) {
            hideLoader();
            commit(SET_INSIGHTS_API_ERROR, { error });
        }
    };

    return axios.get('/api/insights', {
        params,
        cancelToken,
    })
        .then(onSuccess)
        .catch(onError);
}

export function fetchAvailableFilters({ commit }) {
    const onSuccess = ({ data }) => {
        commit(SET_AVAILABLE_INSIGHT_FILTERS, { filters: data });
    };

    return axios.get('/api/insights-filter')
        .then(onSuccess);
}

export function setQuery({ commit }, { query }) {
    commit(SET_INSIGHT_QUERY, { query });
}

export function resetInsights({ commit }) {
    commit(SET_IS_LOADING_INSIGHTS, { isLoading: true });
    commit(RESET_INSIGHTS);
}
